<ejs-tooltip [content]='tooltipText' position="BottomCenter">
  <div class="label {{labelType}} cursor-pointer">
    {{ value }}
  </div>
</ejs-tooltip>